import React, { useEffect, useState } from "react";

import {
  Modal,
  Form,
  Input,
  InputNumber,
  Select,
  Switch,
  Row,
  Col,
} from "antd";

import { postAPI, displayMessage } from "../../utils/common";

import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";

import { SMART_PRICE_CREATE_PRICING_RULE, SMART_PRICE_UPDATE_PRICING_RULE } from "../../constants/api";

function PricingRuleModal({ open, close, editData, afterSave }) {
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      if (editData) {
        form.setFieldsValue({
          rule_key: editData.rule_key,

          title: editData.title,

          value: editData.value,

          type: editData.type,

          is_active: editData.is_active == 1,
        });
      } else {
        form.resetFields();

        form.setFieldsValue({
          type: "number",

          is_active: true,
        });
      }
    }
  }, [open, editData]);

  const submitData = (values) => {
    setLoading(true);

    const data = new FormData();

    if (editData) {
      data.append("id", editData.id);
    }

    data.append("rule_key", values.rule_key);

    data.append("title", values.title);

    data.append("value", values.value ?? "");

    data.append("type", values.type);

    data.append("is_active", values.is_active ? 1 : 0);

    const successFn = (res) => {
      if (res.status === true) {
        setLoading(false);

        displayMessage(
          SUCCESS_MESSAGE,

          res.message,
        );

        form.resetFields();

        afterSave();
      } else {
        setLoading(false);

        displayMessage(
          ERROR_MSG_TYPE,

          res.message,
        );
      }
    };

    const errorFn = () => {
      setLoading(false);

      displayMessage(
        ERROR_MSG_TYPE,

        "Unable to save pricing rule",
      );
    };

    postAPI(
      editData ? SMART_PRICE_UPDATE_PRICING_RULE : SMART_PRICE_CREATE_PRICING_RULE,

      data,

      successFn,

      errorFn,
    );
  };

  return (
    <Modal
      title={editData ? "Update Pricing Rule" : "Add Pricing Rule"}
      open={open}
      onCancel={close}
      okText={editData ? "Update" : "Save"}
      onOk={() => {
        form.submit();
      }}
      confirmLoading={loading}
      destroyOnClose
    >
      <Form layout="vertical" form={form} onFinish={submitData}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="rule_key"
              label="Rule Key"
              rules={[
                {
                  required: true,

                  message: "Rule key is required",
                },
              ]}
            >
              <Input
                placeholder="Example: weekend_score"
                disabled={!!editData}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="title"
              label="Title"
              rules={[
                {
                  required: true,

                  message: "Title is required",
                },
              ]}
            >
              <Input placeholder="Rule title" />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item name="value" label="Value">
              <InputNumber
                style={{
                  width: "100%",
                }}
                placeholder="Value"
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="type"
              label="Type"
              rules={[
                {
                  required: true,

                  message: "Type is required",
                },
              ]}
            >
              <Select
                options={[
                  {
                    label: "Number",

                    value: "number",
                  },

                  {
                    label: "Percentage",

                    value: "percentage",
                  },

                  {
                    label: "Score",

                    value: "score",
                  },
                ]}
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item name="is_active" label="Status" valuePropName="checked">
              <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default PricingRuleModal;
